// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class RequestRecoveryPassword extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_REQUEST_RECOVERY_PASSWORD_MESSAGE, fieldSet);
    }
    setLogin(login) {
        this.setFieldValue(FieldsFactory.FIELD_LOGIN, login);
    }
    setEmail(email) {
        this.setFieldValue(FieldsFactory.FIELD_EMAIL, email);
    }
}
